import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import {
  WebTrackerRequest,
  WebTrackerResponse,
  CustomWebTrackerResponse,
  CustomWebTrackerResponses,
  PageType,
  WebTrackingVendor,
} from '../Modules/Common/Models/WebTracker.model';
import { Observable } from 'rxjs';
import * as _ from 'lodash';

declare var $: any;

@Injectable({ providedIn: 'root' })
export class WebTrackerService {
  constructor(private http: HttpClient) {}

  response?: WebTrackerResponse;

  webtrackerRequest?: WebTrackerRequest;
  customWebTrackerResponse: CustomWebTrackerResponse[] = [];
  webTrackerVendor: WebTrackingVendor[] = [];
  customScriptRendering = {
    All: 1,
    JobSearch: 2,
    CandidateZone: 3,
  };

  loadwebtrackerscript(pageid: any, categoryid: any, jobDetailFields: any) {
    // Initialize the object if it doesn't exist yet
    if (!this.webtrackerRequest) {
      this.webtrackerRequest = {} as WebTrackerRequest;
    }
    this.webtrackerRequest.PartnerId = $('#partnerId').val();
    this.webtrackerRequest.SiteId = $('#siteId').val();
    this.webtrackerRequest.GetBodyTag = true;

    // Assign properties (Note: The interface uses capital 'PageId')
    this.webtrackerRequest.PageId = pageid;
    // Note: 'categoryid' is not in the WebTrackerRequest interface, you may need to add it there if you need it.
    var jobs = (window as any).appScope.jobs;
    var profileid = (window as any).appScope.Abc;
    // GetScript expects parameters and returns an Observable, so we subscribe to it
    this.GetScript(this.webtrackerRequest).subscribe((response) => {
      // This assigns the actual data, not the Observable

      this.response = response;
      if (
        this.response?.customWebTrackerResponse != null &&
        this.response.customWebTrackerResponse?.length > 0
      ) {
        this.customWebTrackerResponse = this.response.customWebTrackerResponse;
        _.forEach(
          this.response.customWebTrackerResponse,
          (customWebTrackerResponse: any) => {
            var executeScript = false;
            var page = '';
            if (
              pageid != null &&
              pageid != '' &&
              pageid.split('/').length > 1
            ) {
              page = pageid.split('/')[2].toLowerCase();
            }
            if (
              customWebTrackerResponse.CategoryIds.toLowerCase().trim() ===
                'all' ||
              (categoryid !== undefined &&
                Object.keys(this.customScriptRendering)
                  [categoryid - 1]?.toLowerCase()
                  .trim()
                  .includes(customWebTrackerResponse.CategoryIds.toLowerCase()))
            ) {
              executeScript = true;
            }
            if (
              customWebTrackerResponse.PageIds != null &&
              customWebTrackerResponse.PageIds != ''
            ) {
              executeScript = false;

              if (
                customWebTrackerResponse.PageIds.toLowerCase()
                  .split(',')
                  .includes(page.toLowerCase())
              ) {
                executeScript = true;
              }

              if (page.toLowerCase() == 'jobdetails' && executeScript) {
                if (
                  customWebTrackerResponse.Fields != null &&
                  customWebTrackerResponse.Fields != ''
                ) {
                  executeScript = false;
                  var fieldsConfig =
                    customWebTrackerResponse.Fields.split('~~');
                  var index = fieldsConfig.length - 1;
                  var matchedFields = 0,
                    totalFields = 0;
                  _.each(fieldsConfig[index].split(';;'), function (field) {
                    totalFields++;
                    var fieldArr = field.split(':');
                    if (fieldArr.length > 1) {
                      var objJobDetQuestion = _.filter(
                        jobDetailFields.JobDetailQuestions,
                        function (obj) {
                          return (
                            obj.VerityZone.toLowerCase().indexOf(
                              fieldArr[0].toLowerCase(),
                            ) != -1
                          );
                        },
                      );
                      if (
                        typeof objJobDetQuestion != 'undefined' &&
                        objJobDetQuestion.length > 0
                      ) {
                        if (
                          fieldArr[1]
                            .toLowerCase()
                            .split('_;_')
                            .includes(
                              objJobDetQuestion[0].AnswerValue.toLowerCase(),
                            )
                        ) {
                          matchedFields++;
                        }
                      }
                    }
                  });
                  if (
                    index > 0 &&
                    fieldsConfig[0] != '' &&
                    fieldsConfig[0].toLowerCase() == 'and'
                  ) {
                    if (totalFields > 0 && totalFields == matchedFields)
                      executeScript = true;
                  } else {
                    if (totalFields > 0 && matchedFields > 0)
                      executeScript = true;
                  }
                }
              }
            }
            if (executeScript) {
              var autoreq = '';
              if (page.toLowerCase() == 'jobdetails') {
                var objAutoreq = _.filter(
                  jobDetailFields.JobDetailQuestions,
                  function (obj) {
                    return (
                      obj.VerityZone.toLowerCase().indexOf('autoreq') != -1
                    );
                  },
                );
                if (typeof objAutoreq != 'undefined' && objAutoreq.length > 0) {
                  autoreq = objAutoreq[0].AnswerValue;
                }
              }
              var Abc: any = typeof Abc != 'undefined' && Abc > 0 ? Abc : -1;

              customWebTrackerResponse.Body.replace(
                /\[BRUID_TOKEN\]/g,
                Abc,
              ).replace(/\[AutoReq\]/g, autoreq);
            }
          },
        );
      }
    });
  }

  GetScript(params: WebTrackerRequest): Observable<WebTrackerResponse> {
    let httpParams = new HttpParams();
    Object.keys(params).forEach((key) => {
      const value = (params as any)[key];
      if (value !== null && value !== undefined) {
        httpParams = httpParams.set(key, value.toString());
      }
    });

    const token = (
      document.querySelector(
        "[name='__RequestVerificationToken']",
      ) as HTMLInputElement
    )?.value;
    if (token) {
      httpParams = httpParams.set('RFT', token);
    }

    return this.http.get<WebTrackerResponse>(
      '/TgNewUI/WebTracker/WebTracker/GetScript',
      { params: httpParams },
    );
  }
}
